import { UseFormReturn } from 'react-hook-form';
import { useLocalization } from '@ais-ui/locale-management';
import { MapFormValues } from './useMapForm';
import { HoverLabelToggle } from './HoverLabelToggle';

interface VesselHoverLabelsProps {
  form: UseFormReturn<MapFormValues>;
}

export const VesselHoverLabels = ({ form }: VesselHoverLabelsProps) => {
  const { messages } = useLocalization();

  const VESSEL_HOVER_FIELDS = [
    { name: 'vessel_mmsi', label: messages.settingsMapShipHoverMmsiLabel, description: messages.settingsMapShipHoverMmsiDescription },
    { name: 'vessel_aisType', label: messages.settingsMapShipHoverAisTypeLabel, description: messages.settingsMapShipHoverAisTypeDescription },
    { name: 'vessel_callSign', label: messages.settingsMapShipHoverCallsignLabel, description: messages.settingsMapShipHoverCallsignDescription },
    { name: 'vessel_imo', label: messages.settingsMapShipHoverImoLabel, description: messages.settingsMapShipHoverImoDescription },
    { name: 'vessel_typeOfShip', label: messages.settingsMapShipHoverTypeOfShipLabel, description: messages.settingsMapShipHoverTypeOfShipDescription },
    { name: 'vessel_typeOfCargo', label: messages.settingsMapShipHoverTypeOfCargoLabel, description: messages.settingsMapShipHoverTypeOfCargoDescription },
    { name: 'vessel_country', label: messages.settingsMapShipHoverCountryLabel, description: messages.settingsMapShipHoverCountryDescription },
    { name: 'vessel_destination', label: messages.settingsMapShipHoverDestinationLabel, description: messages.settingsMapShipHoverDestinationDescription },
    { name: 'vessel_size', label: messages.settingsMapShipHoverSizeLabel, description: messages.settingsMapShipHoverSizeDescription },
    { name: 'vessel_speedOverGround', label: messages.settingsMapShipHoverSpeedOverGroundLabel, description: messages.settingsMapShipHoverSpeedOverGroundDescription },
    { name: 'vessel_courseOverGround', label: messages.settingsMapShipHoverCourseOverGroundLabel, description: messages.settingsMapShipHoverCourseOverGroundDescription },
    { name: 'vessel_heading', label: messages.settingsMapShipHoverHeadingLabel, description: messages.settingsMapShipHoverHeadingDescription },
    { name: 'vessel_draught', label: messages.settingsMapShipHoverDraughtLabel, description: messages.settingsMapShipHoverDraughtDescription },
    { name: 'vessel_navigationalStatus', label: messages.settingsMapShipHoverNavigationalStatusLabel, description: messages.settingsMapShipHoverNavigationalStatusDescription },
  ] as const;

  return (
    <div className="grid grid-cols-2 gap-4">
      {VESSEL_HOVER_FIELDS.map((field) => (
        <HoverLabelToggle
          key={field.name}
          form={form}
          name={field.name}
          label={field.label}
          description={field.description}
        />
      ))}
    </div>
  );
};
